import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card, CardBody } from '../components/ui/Card';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  return <div className="bg-warm-50 min-h-screen pb-20" data-id="element-307">
      {/* Header */}
      <div className="bg-primary-900 text-white py-16" data-id="element-308">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-309">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-310">Get in Touch</h1>
          <p className="text-xl text-primary-100 max-w-2xl mx-auto" data-id="element-311">
            We are here to answer your questions and help you schedule
            transportation or delivery services. Reach out today and let us help
            you move forward safely and affordably.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-312">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-313">
          {/* Contact Info Cards */}
          <div className="lg:w-1/3 space-y-6" data-id="element-314">
            <Card className="border-none shadow-md" data-id="element-315">
              <CardBody className="p-6 flex items-start" data-id="element-316">
                <div className="bg-primary-100 p-3 rounded-lg text-primary-600 mr-4 flex-shrink-0" data-id="element-317">
                  <Phone className="w-6 h-6" data-id="element-318" />
                </div>
                <div data-id="element-319">
                  <h3 className="text-lg font-bold text-warm-900 mb-1" data-id="element-320">
                    Phone
                  </h3>
                  <p className="text-warm-600 mb-2" data-id="element-321">24/7 Dispatch & Booking</p>
                  <a href="tel:2404132157" className="text-xl font-bold text-primary-600 hover:underline" data-id="element-322">
                    (240) 413-2157
                  </a>
                </div>
              </CardBody>
            </Card>

            <Card className="border-none shadow-md" data-id="element-323">
              <CardBody className="p-6 flex items-start" data-id="element-324">
                <div className="bg-primary-100 p-3 rounded-lg text-primary-600 mr-4 flex-shrink-0" data-id="element-325">
                  <Mail className="w-6 h-6" data-id="element-326" />
                </div>
                <div data-id="element-327">
                  <h3 className="text-lg font-bold text-warm-900 mb-1" data-id="element-328">
                    Email
                  </h3>
                  <p className="text-warm-600 mb-2" data-id="element-329">General Inquiries</p>
                  <a href="mailto:Podogwu100@gmail.com" className="text-lg font-medium text-primary-600 hover:underline" data-id="element-330">
                    Podogwu100@gmail.com
                  </a>
                </div>
              </CardBody>
            </Card>

            <Card className="border-none shadow-md" data-id="element-331">
              <CardBody className="p-6 flex items-start" data-id="element-332">
                <div className="bg-primary-100 p-3 rounded-lg text-primary-600 mr-4 flex-shrink-0" data-id="element-333">
                  <MapPin className="w-6 h-6" data-id="element-334" />
                </div>
                <div data-id="element-335">
                  <h3 className="text-lg font-bold text-warm-900 mb-1" data-id="element-336">
                    Office Address
                  </h3>
                  <p className="text-warm-600 leading-relaxed" data-id="element-337">
                    123 Mobility Way
                    <br data-id="element-338" />
                    Suite 100
                    <br data-id="element-339" />
                    Metro City, ST 12345
                  </p>
                </div>
              </CardBody>
            </Card>

            <Card className="border-none shadow-md bg-warm-900 text-white" data-id="element-340">
              <CardBody className="p-6 flex items-start" data-id="element-341">
                <div className="bg-warm-800 p-3 rounded-lg text-warm-300 mr-4 flex-shrink-0" data-id="element-342">
                  <Clock className="w-6 h-6" data-id="element-343" />
                </div>
                <div data-id="element-344">
                  <h3 className="text-lg font-bold mb-1" data-id="element-345">Business Hours</h3>
                  <div className="space-y-1 text-warm-300 text-sm" data-id="element-346">
                    <p className="flex justify-between" data-id="element-347">
                      <span className="font-medium text-white" data-id="element-348">
                        Transportation:
                      </span>{' '}
                      24/7
                    </p>
                    <p className="flex justify-between" data-id="element-349">
                      <span className="font-medium text-white" data-id="element-350">Dispatch:</span>{' '}
                      24/7
                    </p>
                    <p className="flex justify-between" data-id="element-351">
                      <span className="font-medium text-white" data-id="element-352">
                        Admin Office:
                      </span>{' '}
                      Mon-Fri, 8am-5pm
                    </p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>

          {/* Contact Form */}
          <div className="lg:w-2/3" data-id="element-353">
            <Card className="border-none shadow-lg h-full" data-id="element-354">
              <CardBody className="p-8 md:p-10" data-id="element-355">
                <h2 className="text-2xl font-bold text-warm-900 mb-6" data-id="element-356">
                  Send us a Message
                </h2>

                {isSuccess ? <div className="bg-green-50 border border-green-200 rounded-xl p-8 text-center h-full flex flex-col justify-center items-center" data-id="element-357">
                    <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-4" data-id="element-358">
                      <Send className="w-8 h-8" data-id="element-359" />
                    </div>
                    <h3 className="text-2xl font-bold text-green-800 mb-2" data-id="element-360">
                      Message Sent!
                    </h3>
                    <p className="text-green-700 mb-6" data-id="element-361">
                      Thank you for reaching out. A member of our team will get
                      back to you within 24 hours.
                    </p>
                    <Button onClick={() => setIsSuccess(false)} variant="outline" data-id="element-362">
                      Send Another Message
                    </Button>
                  </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-363">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-364">
                      <Input label="First Name" required data-id="element-365" />
                      <Input label="Last Name" required data-id="element-366" />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-367">
                      <Input label="Email Address" type="email" required data-id="element-368" />
                      <Input label="Phone Number" type="tel" data-id="element-369" />
                    </div>

                    <Input label="Subject" options={[{
                  value: 'quote',
                  label: 'Request a Quote'
                }, {
                  value: 'booking',
                  label: 'Question about a Booking'
                }, {
                  value: 'partnership',
                  label: 'Facility Partnership Inquiry'
                }, {
                  value: 'employment',
                  label: 'Employment Opportunities'
                }, {
                  value: 'other',
                  label: 'Other'
                }]} required data-id="element-370" />

                    <Input label="Message" multiline required placeholder="How can we help you today?" data-id="element-371" />

                    <Button type="submit" size="lg" className="w-full md:w-auto" disabled={isSubmitting} data-id="element-372">
                      {isSubmitting ? 'Sending...' : 'Send Message'}
                    </Button>
                    <p className="text-xs text-warm-500 mt-4" data-id="element-373">
                      For immediate transportation needs or to cancel an
                      existing ride, please call us directly instead of using
                      this form.
                    </p>
                  </form>}
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </div>;
}